<template>
<div>
    <p>To prevent spam, the major cell phone carries require that you register your organization with The Campaign Registry (TCR).  RedChirp handles this for you using the information you provide below.</p>

    <m-text-validate-field
        label="Legal Company Name"
        v-model="tcr_setup_data.organization_legal_name"
        hint="This should match *exactly* what the IRS has on file for your company's EIN."
        v-on:input="update"
        persistent-hint
        required
    />

    <v-checkbox
        label="Does your business have a different DBA (Doing Business As)?"
        v-model="tcr_setup_data.has_dba"
        v-on:change="doUpdate"
    />

    <m-text-validate-field
        label="DBA"
        v-model="tcr_setup_data.dba"
        autocomplete="off"
        v-on:input="update"
        v-if="tcr_setup_data.has_dba"
        hint="DBA or Brand Name, if different from legal name"
        required
    />

    <v-select
        label="Legal Form"
        v-model="tcr_setup_data.tcr_legal_form"
        :items="$rc.enumChoices('tcr_organiztion_legal_form',false)"
        hint="Choose which best describes your organization. Most RedChirp customers choose 'Private Company'"
        persistent-hint
        v-on:change="doUpdate"
    />

    <m-text-validate-field
        label="Tax Identification Number"
        v-model="tcr_setup_data.tax_id"
        v-on:input="update"
        style="margin-top: 15px"
        us_or_ca_tax_id
        required
    />

    <ul
        style="margin-bottom: 15px"
    >
        <li>US Businesses: Use your Employer Identification Number (EIN) </li>
        <ul
            style="margin-bottom: 15px"
        >
            <li>Nine digits</li>
        </ul>


        <li>Canadian Businesses: Nine Digit Business Number (BN 9) </li>
        <ul>
            <li>Nine Digits</li>
            <li>Do <b>not</b> use your BN15</li>
        </ul>
    </ul>

    <m-text-validate-field
        label="Business Address"
        v-model="tcr_setup_data.business_address"
        v-on:input="update"
        hint="This should match exactly what's on file with the IRS and/or your state/province's business registration office" 
        required
    />

    <v-row>
        <v-col>
            <m-text-validate-field
                label="City"
                v-model="tcr_setup_data.business_address_city"
                v-on:input="update"
                required
            />
        </v-col>

        <v-col>
            <m-text-validate-field
                label="State"
                v-model="tcr_setup_data.business_address_state"
                v-on:input="update"
                required
            />
        </v-col>

        <v-col>
            <m-text-validate-field
                label="Zip / Postal Code"
                v-model="tcr_setup_data.business_address_zip"
                v-on:input="update"
                required
            />
        </v-col>

        <v-col>
            <v-select
                label="Country"
                v-model="tcr_setup_data.country"
                :items="$rc.enumChoices('tcr_country',false)"
                persistent-hint
                v-on:change="doUpdate"
            />
        </v-col>
    </v-row>

    <v-select
        label="Which best describes your business vertical (pick one)"
        v-model="tcr_setup_data.tcr_business_category"
        :items="biz_category_choices"
        v-on:change="doUpdate"
    />

     <m-text-validate-field
        label="TCR Point of Contact Email Address"
        v-model="tcr_setup_data.tcr_contact_email"
        v-on:input="update"
        hint="The Campaign Registry requires we provide an (official) email address for one contact (the primary point of contact) at your organization.  This email address is used in your default response to the HELP CTIA keyword" 
        persistent-hint
        required
        email
    />

    <m-text-validate-field
        label="TCR Point of Contact Phone Number"
        v-model="tcr_setup_data.tcr_phone_number"
        v-on:input="update"
        hint="The Campaign Registry requires we provide an (official) phone number for one contact (the primary point of contact) at your organization." 
        persistent-hint
        required
        phone
    />

    <m-text-validate-field
        label="Website"
        v-model="tcr_setup_data.website"
        autocomplete="off"
        v-on:input="update"
        hint="Your organization's primary website (e.g. for Microsoft, https://www.microsoft.com)" 
        persistent-hint
        required
        url
    />

    <m-text-validate-field
        label="Privacy Policy"
        v-model="tcr_setup_data.url_privacy_policy"
        autocomplete="off"
        v-on:input="update"
        hint="The web address (URL) for your organization's privacy policy (e.g. for Microsoft, https://privacy.microsoft.com/en-us/privacystatement)" 
        persistent-hint
        required
        url
    />

    <v-select
        label="Text Messaging Privacy Policy Addendum"
        v-model="tcr_setup_data.privacy_policy_addendum"
        :items="privacy_policy_addendum_options"
        v-on:change="update"
    />

    <p>
        For details on the carrier's requirements for your privacy policy <a target="_blank" href="https://redchirp.com/texting-requirements-of-your-privacy-policy/">click here</a>.  <br/><br/>
        To review the RedChirp text messaging privacy policy addendum <a style="text-decoration: underline" v-on:click="onClickFormPrivacyPolicyAddendum()">click here</a>.
    </p>

    <m-text-validate-field
        label="Website Terms and Conditions"
        v-model="tcr_setup_data.url_terms_and_conditions"
        autocomplete="off"
        v-on:input="update"
        hint="The web address (URL) for your organization's terms and conditions (e.g. for Microsoft, https://www.microsoft.com/en-us/legal/terms-of-use)" 
        persistent-hint
        required
        url
    />

    <v-select
        label="Text Messaging Terms and Conditions Addendum"
        v-model="tcr_setup_data.terms_and_conditions_addendum"
        :items="terms_and_conditions_addendum_options"
        v-on:change="update"
    />

    <p>
        For details on the carrier's requirements for your terms and conditions <a target="_blank" href="https://redchirp.com/texting-requirements-and-your-websites-terms-and-conditions/">click here</a>.<br/><br/>
        To review the RedChirp text messaging terms and conditions addendum <a style="text-decoration: underline" v-on:click="onClickFormTermsAndConditionsAddendum()">click here</a>.
    </p>
   
</div>
</template>

<script>
const _ = require('lodash');
const Validate = require('@/js/validate.js');
export default 
{
    props: {
        profile: {
            type: Object,
            default: function() { return {}; },
        },
    },

    data() {
        return {
            tcr_setup_data: {},
            biz_category_choices: [
                "Agriculture",
                "Media and Communication",
                "Construction, Materials, and Trade Services",
                "Education",
                "Energy and Utilities",
                "Entertainment",
                "Financial Services",
                "Gambling and Lottery",
                "Government Services and Agencies",
                "Healthcare and Life Sciences",
                "Hospitality and Travel",
                "HR, Staffing or Recruitment",
                "Insurance",
                "Legal",
                "Manufacturing",
                "Non-profit Organization",
                "Political",
                "Postal and Delivery",
                "Professional Services",
                "Real Estate",
                "Retail and Consumer Products",
                "Information Technology Services",
                "Transportation or Logistics",
            ],

            terms_and_conditions_addendum_options: [
                {'text': 'Adopt and use the RedChirp text messaging terms and conditions addendum to satisfy the carrier\'s vetting requirements', 'value': 'use-form-addendum'},
                {'text': 'We have updated our website\'s terms and conditions to satisfy the carrier\'s vetting requirements (may require updating as new requirements are released)', 'value': 'do-not-use-form-addendum'},

            ],

            privacy_policy_addendum_options: [
                {'text': 'Adopt and use the RedChirp text messaging privacy policy addendum to satisfy the carrier\'s vetting requirements', 'value': 'use-form-addendum'},
                {'text': 'We have updated our website\'s privacy policy to satisfy the carrier\'s vetting requirements (may require updating as new requirements are released)', 'value': 'do-not-use-form-addendum'},
            ],
        }
    },

    mounted () {
        this.tcr_setup_data = _.cloneDeep(this.profile.tcr_setup_data);

        if ( this.tcr_setup_data.country == null )
            this.tcr_setup_data.country = 'us';
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/tcr-organization-setup-data',
            
                'params' : this.tcr_setup_data,
            
                'on_success': (data) => {
                        if ( data.complete == true )
                        {
                            this.$emit('reload');
                        }
                    },
            
                'on_error': 'Unable to save form data',
            });
        },

        myRule(value)
        {
            if ( Validate.isEmailAddresses(value) )
                return true;

            return 'Must be a valid email addresss';
        },

        onClickFormPrivacyPolicyAddendum()
        {
            let url = this.$router.resolve({
                'name': 'default-privacy-policy-addendum',
                'params' : {
                    'organization_id' : this.profile.organization_id,
                }
            });

            window.open(url.href,"_blank");  
        },

        onClickFormTermsAndConditionsAddendum()
        {
            let url = this.$router.resolve({
                'name': 'default-terms-and-conditions-addendum',
                'params' : {
                    'organization_id' : this.profile.organization_id,
                }
            });

            window.open(url.href,"_blank");  
        },
    },
}
</script>

<style lang="scss" scoped>

</style>